let navigate;

const setNavigate = (navigateObj) => (navigate = navigateObj);

export { navigate, setNavigate };
